import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {removeEntity, setAllEntities, setEntity, withEntities} from '@ngrx/signals/entities';
import {LoRaGatewayStatus} from 'src/app/infrastructure/moovement-api/models/asset';

const config = { selectId: (status: LoRaGatewayStatus) => status.deviceId };

export const GatewayStatusStore = signalStore(
  { providedIn: 'root' },
  withState({
    loading: true
  }),
  withEntities<LoRaGatewayStatus>(),
  withMethods((store) => ({
    setAllEntities(statuses?: LoRaGatewayStatus[]) {
      patchState(store, setAllEntities(statuses || [], config), { loading: false });
    },
    setEntity(status: LoRaGatewayStatus) {
      patchState(store, setEntity(status, config))
    },
    removeEntity(id: string) {
      patchState(store, removeEntity(id))
    }
  }))
);
